const actionTypeIdentifier = '42E7CC47-818F-4BAC-BA01-59C10954A0B6'; //this is a newid
export const setDefaultContract = `SET-DEFAULT-CONTRACT-${actionTypeIdentifier}`;
export const getContract = `GET-CONTRACT-${actionTypeIdentifier}`;
export const setContractError = `SET-CONTRACT-${actionTypeIdentifier}`;
export const setContractColSearchStr = `SET-CONTRACT-COL-SEARCH-STR-${actionTypeIdentifier}`;
export const sortContractList = `SORT-CONTRACT-LIST-${actionTypeIdentifier}`;
export const setContractListPageSizes = `SET-CONTRACT-LIST-PAGE-SIZES${actionTypeIdentifier}`;
export const setContractFilter = `SET-CONTRACT-FILTER${actionTypeIdentifier}`;
export const applyContractFilter = `APPLY-CONTRACT-FILTER${actionTypeIdentifier}`;
export const getContractComments = `GET-CONTRACT-COMMENTS${actionTypeIdentifier}`;
export const insertToContractComment = `INSERT-CONTRACT-COMMENTS${actionTypeIdentifier}`;
export const resetContractComments = `RESET-CONTRACT-COMMENTS${actionTypeIdentifier}`;